import Layout from '../components/Layout'
import { PageHeader, Section, Card } from '../components/UIComponents'
import { useState } from 'react'

export default function Send() {
  const [recipient, setRecipient] = useState('')
  const [amount, setAmount] = useState('')

  return (
    <Layout>
      <div className="space-y-8 max-w-4xl mx-auto">
        <PageHeader
          icon="📤"
          title="Enviar Fondos"
          description="Envía criptomonedas o dinero a otros usuarios"
        />

        <Section title="Formulario de Envío">
          <Card>
            <div className="space-y-4">
              <div>
                <label className="block text-slate-300 text-sm font-medium mb-2">
                  Destinatario
                </label>
                <input
                  type="email"
                  placeholder="correo@ejemplo.com"
                  value={recipient}
                  onChange={(e) => setRecipient(e.target.value)}
                  className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-slate-300 text-sm font-medium mb-2">
                  Monto
                </label>
                <div className="flex gap-2">
                  <input
                    type="number"
                    placeholder="0.00"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    className="flex-1 px-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:border-blue-500"
                  />
                  <select className="px-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white focus:outline-none focus:border-blue-500">
                    <option>USD</option>
                    <option>ETH</option>
                    <option>USDC</option>
                  </select>
                </div>
              </div>

              <button className="w-full px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-lg transition-all">
                Enviar Ahora
              </button>
            </div>
          </Card>
        </Section>
      </div>
    </Layout>
  )
}
